import { PowerUpType } from "../../data/enums";
import { PowerUpBase } from "./PowerUpBase";

export class WeaponPowerUp extends PowerUpBase {
    constructor(scene: Phaser.Scene, x: number, y: number, powerUpType: PowerUpType.Trident | PowerUpType.Bow) {
        const textureKey = powerUpType === PowerUpType.Trident ? "powerup-trident" : "powerup-bow";
        super(scene, x, y, textureKey, powerUpType, 20000);
    }
}
